<template>
  <div>
    <md-dialog :md-active="open" class="modalEdit modal-img-archive">
      <div class="w-100 position-fixed mobile-cancel">
        <span
          class="material-icons close text-right"
          @click="closeModal"
        >close</span
        >
      </div>
      <div class="body-modal-img-archive py-5 modal-body">
        <md-dialog-title class="md-title pb-3 add-category text-left">
          {{ item?.id ? 'EDITAR' : 'AGREGAR' }} ENLACE
        </md-dialog-title>

        <div class="dialog-body">
          <div class="row">
            <div class="form-group col-md-12 mb-2 pt-0">
              <h4 class="text-bold mb-3 float-left">NOMBRE</h4>
              <base-input
                v-model="media.title"
                name="name"
                placeholder="Titulo del archivo."
              ></base-input>
            </div>
            <div class="form-group col-md-12 mb-2">
              <h4 class="text-bold mb-3 float-left">DESCRIPCIÓN</h4>
              <textarea
                v-model="media.description"
                name="description"
                class="form-control"
                placeholder="Coloca la descripción."
                rows="3"
              ></textarea>
            </div>
            <div class="form-group col-md-12 mb-2 text-left">
              <h4 class="text-bold mb-3 mt-4 float-left">ENLACE</h4>
              <base-input
                v-model="media.url"
                name="link"
                placeholder="Insertar link"
              ></base-input>
            </div>
          </div>
        </div>

        <md-dialog-actions class="modal-footer">
          <md-button class="btn-primary w-auto" @click="closeModal">
            CANCELAR
          </md-button>
          <base-button
            :loading="isLoading"
            class="btn-primary ml-0 w-auto"
            @click="item?.id ? updateMediaLink() : createMediaLink()"
          >
            {{ item?.id ? 'EDITAR' : 'AGREGAR' }}
          </base-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {
  MEDIA_CREATE_FILE,
  MEDIA_UPDATE_FILE,
} from '@/store/actions/media';
import validator
  from 'validator';

export default {
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },
    categorySelected: {
      type: Number || String,
      default: null,
    },
  },
  emits: ['close-modal', 'success'],
  data () {
    return {
      isLoading: false,

      media: {
        title: '',
        description: '',
        url: '',
      },
    };
  },
  computed: {
    open: {
      get: function() {
        return this.active;
      },
      set: function() {
        this.closeModal();
      },
    },
  },
  watch: {
    item: function(newVal) {
      if (newVal) {
        this.media = {
          id: newVal.id,
          title: newVal.title,
          description: newVal.description,
          url: newVal.file_url,
        };
      }
    },
  },
  methods: {
    async createMediaLink () {
      this.isLoading = true;
      if (!(validator.default.isURL(this.media.url) && this.media.url)) {
        this.isLoading = false;
        return this.notify(
          'danger',
          'Enlace no valido',
        );
      }

      try {
        const data = {
          title: this.media.title,
          description: this.media.description,
          type: 'url',
          file_url: this.media.url,
        };

        await this.$store
          .dispatch(MEDIA_CREATE_FILE, data);

        this.notify(
          'success',
          'Se ha creado el enlace correctamente',
        );
      } catch {
        this.isLoading = false;
        return this.notify('danger', 'Tenemos problemas para crear el archivo');

      }
      return this.closeModal();
    },
    async updateMediaLink () {
      if (!(validator.default.isURL(this.media.url) && this.media.url)) {
        this.isLoading = false;
        return this.notify(
          'danger',
          'Enlace no valido',
        );
      }
      this.isLoading = true;
      try {

        const data = {
          id: this.media.id,
          title: this.media.title,
          description: this.media.description,
          type: 'url',
          file_url: this.media.url,
        };

        await this.$store
          .dispatch(MEDIA_UPDATE_FILE, data);
        this.notify('success', 'Se ha actualizado el enlace correctamente');

      } catch {
        this.isLoading = false;
        return this.notify('error', 'Tenemos problemas para actualizar el enlace');

      }

      return this.closeModal();
    },

    closeModal () {
      this.$emit('close-modal', 'mediaUrl');
      this.$emit('success');
      this.isLoading = false;
      this.val = {
        title: null,
        description: null,
        url: null,
      };
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>
